import { Http } from '../axios/interceptors'


export const allCompaniesTypes = async (param) => Http('GET', '/CompaniesTypes/GetList?', param)

export const getCompanieType = async guid => Http('GET', `/CompaniesTypes/Get?guid=${guid}`)

export const createOrEditCompanieType = async (body, id = null) => (id ? Http('PUT', `/CompaniesTypes/Update`, null, body) : Http('POST', '/CompaniesTypes/Create', null, body))

export const deleteCompanieType = async guid => Http('DELETE', `/CompaniesTypes/Delete?guid=${guid}`)
